// extracted by mini-css-extract-plugin
export default {"wrapper":"NewMineralsComponent_wrapper__aNAeP"};